import { trpc } from '@/shared/api/trpc';

export const useClearPasswordChangeObligation = () =>
  trpc.accounts.clearPasswordChangeObligation.useMutation();
